(function () {
  'use strict';

  var AV = window.Auravitia || {};
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function announce(message) {
    var region = document.getElementById('av-live-region');
    if (region) {
      region.textContent = '';
      requestAnimationFrame(function () {
        region.textContent = message;
      });
    }
  }

  function parseSectionHTML(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-section-id="' + sectionId + '"]') ||
      doc.querySelector('cart-drawer') ||
      doc.querySelector('ajax-cart') ||
      doc.body.firstElementChild;
  }

  function trapFocus(container, previousFocus) {
    var focusable = $$(FOCUSABLE, container).filter(function (el) {
      return el.offsetParent !== null || el === container;
    });

    if (!focusable.length) return function () {};

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeyDown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeyDown);
    first.focus();

    return function release() {
      container.removeEventListener('keydown', onKeyDown);
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    };
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
    var label = $('[data-cart-count-label]');
    if (label) {
      label.textContent = count + (count === 1 ? ' item' : ' items');
    }
    $$('[data-cart-open]').forEach(function (btn) {
      btn.classList.remove('av-cart-bump');
      void btn.offsetWidth;
      btn.classList.add('av-cart-bump');
    });
  }

  /* ─── CartDrawer (cart-drawer element) ─── */
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId || 'cart-drawer-ajax';
      this.isOpen = false;
      this.releaseFocus = null;
      this.boundOnKeyDown = this.onKeyDown.bind(this);
      this.boundOnCartUpdated = this.onCartUpdated.bind(this);
      this.noteDebounce = AV.debounce(this.saveNote.bind(this), 500);
    }

    connectedCallback() {
      this.overlay = $('[data-cart-overlay]', this);
      this.panel = $('[data-cart-panel]', this);
      this.bindEvents();
      document.addEventListener('cart:updated', this.boundOnCartUpdated);
      document.addEventListener('cart:open', this.open.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.boundOnCartUpdated);
      document.removeEventListener('keydown', this.boundOnKeyDown);
    }

    bindEvents() {
      var self = this;

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) {
          e.preventDefault();
          self.open();
        }
      });

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
          e.preventDefault();
          self.close();
        }

        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          var line = qtyBtn.dataset.line;
          var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
          var input = self.querySelector('[data-qty-input][data-line="' + line + '"]');
          if (input) {
            var next = Math.max(0, parseInt(input.value, 10) + delta);
            self.changeLine(line, next);
          }
        }

        var removeBtn = e.target.closest('[data-remove-line]');
        if (removeBtn) {
          e.preventDefault();
          self.changeLine(removeBtn.dataset.removeLine, 0);
        }
      });

      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-qty-input]')) {
          var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
          self.changeLine(e.target.dataset.line, qty);
        }
      });

      this.addEventListener('input', function (e) {
        if (e.target.matches('[data-cart-note]')) {
          self.noteDebounce(e.target.value);
        }
      });

      this.addEventListener('click', function (e) {
        var applyBtn = e.target.closest('[data-discount-apply]');
        if (!applyBtn) return;
        e.preventDefault();
        self.applyDiscount(applyBtn);
      });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
          e.preventDefault();
          var btn = self.querySelector('[data-discount-apply]');
          if (btn) self.applyDiscount(btn);
        }
      });
    }

    applyDiscount(applyBtn) {
      var input = this.querySelector('[data-discount-input]');
      var msg = this.querySelector('[data-discount-msg]');
      var code = input && input.value.trim();
      if (!code) return;

      applyBtn.disabled = true;
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () {
          if (msg) {
            msg.textContent = 'Code ' + code.toUpperCase() + ' saved. It is applied at checkout.';
            msg.classList.add('av-telemetry--green');
            msg.hidden = false;
          }
          announce('Discount code saved');
        })
        .catch(function () {
          if (msg) {
            msg.textContent = 'Could not save code — try again';
            msg.classList.remove('av-telemetry--green');
            msg.hidden = false;
          }
        })
        .finally(function () {
          applyBtn.disabled = false;
        });
    }

    onKeyDown(e) {
      if (e.key === 'Escape' && this.isOpen) this.close();
    }

    onCartUpdated(e) {
      var detail = e.detail || {};
      if (detail.open !== false) this.open();
      this.refresh(detail);
    }

    open() {
      this.syncRefs();
      if (this.isOpen) return;
      this.isOpen = true;
      this.classList.add('av-drawer--open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('av-body--drawer-open');
      document.addEventListener('keydown', this.boundOnKeyDown);
      this.previousFocus = document.activeElement;
      this.releaseFocus = trapFocus(this.panel, this.previousFocus);
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('av-drawer--open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('av-body--drawer-open');
      document.removeEventListener('keydown', this.boundOnKeyDown);
      if (this.releaseFocus) {
        this.releaseFocus();
        this.releaseFocus = null;
      }
    }

    /* v23: re-read the panel and overlay every time. Other scripts may replace
       the drawer's contents, and a stale reference made +/- update a detached
       panel, so the quantity on screen never changed. */
    syncRefs() {
      this.panel = $('[data-cart-panel]', this) || this.panel;
      this.overlay = $('[data-cart-overlay]', this) || this.overlay;
    }

    refresh(detail) {
      var self = this;
      this.syncRefs();
      this.classList.add('av-cart-drawer--loading');

      return AV.fetchSection(this.sectionId).then(function (html) {
        var newSection = parseSectionHTML(html, self.sectionId);
        if (!newSection) return;

        var newPanel = $('[data-cart-panel]', newSection);
        if (newPanel && self.panel) {
          self.panel.innerHTML = newPanel.innerHTML;
        } else {
          var newBody = $('[data-cart-body]', newSection);
          var body = $('[data-cart-body]', self);
          if (newBody && body) body.innerHTML = newBody.innerHTML;
        }

        self.classList.toggle('av-drawer--empty', !$('[data-cart-items]', self));

        if (detail && typeof detail.item_count === 'number') {
          updateCartCount(detail.item_count);
        }

        var addedId = detail && detail.item && (detail.item.variant_id || detail.item.id);
        if (addedId) {
          var addedLine = $('[data-line-variant="' + addedId + '"]', self);
          if (addedLine) {
            addedLine.classList.add('av-drawer__item--added');
            setTimeout(function () {
              addedLine.classList.remove('av-drawer__item--added');
            }, 1200);
          }
        }

        announce(AV.strings.cartUpdated || 'Cart updated');
      }).catch(function (err) {
        console.error('[AjaxCart] refresh failed', err);
      }).finally(function () {
        self.classList.remove('av-cart-drawer--loading');
      });
    }

    changeLine(line, quantity) {
      var self = this;
      this.classList.add('av-cart-drawer--loading');

      return fetch(AV.routes.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart change failed');
          return r.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return self.refresh({ item_count: cart.item_count, open: true });
        })
        .catch(function (err) {
          console.error('[AjaxCart] changeLine failed', err);
          self.classList.remove('av-cart-drawer--loading');
        });
    }

    saveNote(note) {
      fetch(AV.routes.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ note: note })
      }).catch(function (err) {
        console.error('[AjaxCart] note save failed', err);
      });
    }
  }

  /* ─── VariantSelects ─── */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.product = null;
      this.currentVariant = null;
    }

    connectedCallback() {
      this.form = $('form[data-product-form]', this);
      this.idInput = $('[data-variant-id]', this);
      this.jsonEl = document.getElementById(this.dataset.productJsonId);
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.url;

      if (!this.form || !this.idInput || !this.jsonEl) return;

      try {
        this.product = JSON.parse(this.jsonEl.textContent);
      } catch (e) {
        console.error('[VariantSelector] invalid product JSON', e);
        return;
      }

      this.bindOptions();
      this.bindFormQty();
      this.bindAddToCart();
      this.bindThumbs();
      this.syncFromUrl();
    }

    bindOptions() {
      var self = this;
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || btn.disabled || !btn.matches('.av-pdp__option-btn, .av-pdp__option-btn--on')) return;

        var fieldset = btn.closest('[data-option-index]');
        if (!fieldset) return;

        $$('.av-pdp__option-btn, [data-option-value].av-pdp__option-btn', fieldset).forEach(function (b) {
          b.classList.remove('av-pdp__option-btn--selected', 'av-pdp__option-btn--on');
        });
        btn.classList.add('av-pdp__option-btn--selected', 'av-pdp__option-btn--on');

        var index = fieldset.dataset.optionIndex;
        var valueEl = $('[data-option-value="' + index + '"]', self);
        if (valueEl) valueEl.textContent = btn.dataset.optionValue;

        self.updateVariant();
      });
    }

    bindFormQty() {
      var input = $('[data-form-qty-input]', this);
      if (!input) return;

      this.addEventListener('click', function (e) {
        var dec = e.target.closest('[data-form-qty="-1"]');
        var inc = e.target.closest('[data-form-qty="1"]');
        if (!dec && !inc) return;
        e.preventDefault();
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + (inc ? 1 : -1));
      });
    }

    bindThumbs() {
      var thumbsWrap = document.querySelector('[data-pdp-thumbs]');
      if (!thumbsWrap) return;
      thumbsWrap.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-id]');
        if (!thumb) return;
        var id = thumb.dataset.thumbId;
        document.querySelectorAll('[data-media-id]').forEach(function (item) {
          item.classList.toggle('av-pdp__media-item--active', item.dataset.mediaId === id);
        });
        $$('[data-thumb-id]', thumbsWrap).forEach(function (t) {
          t.classList.toggle('av-pdp__thumb--active', t === thumb);
        });
      });
    }

    getSelectedOptions() {
      var selected = [];
      $$('[data-option-index]', this).forEach(function (fieldset) {
        var btn = $('.av-pdp__option-btn--selected, .av-pdp__option-btn--on', fieldset);
        selected.push(btn ? btn.dataset.optionValue : null);
      });
      return selected;
    }

    findVariant(options) {
      return this.product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    updateVariant() {
      var options = this.getSelectedOptions();
      var variant = this.findVariant(options);
      if (!variant) return;

      this.currentVariant = variant;
      this.idInput.value = variant.id;
      this.updatePrice(variant);
      this.updateAvailability(variant);
      this.updateImage(variant);
      this.updateUrl(variant);
    }

    updatePrice(variant) {
      var priceEl = document.querySelector('[data-pdp-price]');
      var compareEl = document.querySelector('[data-pdp-compare-price]');
      if (priceEl) priceEl.textContent = AV.formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = AV.formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      announce('Price updated to ' + AV.formatMoney(variant.price));
      document.querySelectorAll('[data-sticky-variant-id]').forEach(function (el) {
        if (parseInt(el.value, 10) !== variant.id) el.value = variant.id;
      });
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
        el.textContent = AV.formatMoney(variant.price);
      });
    }

    updateAvailability(variant) {
      var skuEl = document.querySelector('[data-pdp-sku]');
      var availEl = document.querySelector('[data-pdp-availability]');
      var addBtn = $('[data-add-to-cart]', this);
      var addText = $('[data-add-to-cart-text]', this);

      if (skuEl) skuEl.textContent = 'SKU::' + (variant.sku || 'N/A');
      if (availEl) {
        availEl.textContent = variant.available ? 'STOCK::IN_RANGE' : 'STOCK::DEPLETED';
        availEl.classList.toggle('av-telemetry--green', variant.available);
        availEl.classList.toggle('av-telemetry--muted', !variant.available);
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) {
        addText.textContent = variant.available
          ? (addText.dataset.defaultLabel || AV.strings.addToCart || 'Add to cart')
          : (AV.strings.soldOut || 'Sold out');
      }
    }

    updateImage(variant) {
      if (!variant.featured_media_id && !variant.featured_image) return;
      var mediaId = String(variant.featured_media_id || '');
      document.querySelectorAll('[data-media-id]').forEach(function (item) {
        if (mediaId) item.classList.toggle('av-pdp__media-item--active', item.dataset.mediaId === mediaId);
      });
      var thumbsWrap = document.querySelector('[data-pdp-thumbs]');
      if (thumbsWrap && mediaId) {
        $$('[data-thumb-id]', thumbsWrap).forEach(function (t) {
          t.classList.toggle('av-pdp__thumb--active', t.dataset.thumbId === mediaId);
        });
      }
      if (variant.featured_image && !mediaId) {
        this.setMainImage(variant.featured_image.src, variant.featured_image.src + ' 1200w', variant.featured_image.alt);
      }
    }

    setMainImage(src, srcset, alt) {
      var main = document.querySelector('[data-pdp-main-image]');
      if (!main) return;
      if (main.tagName === 'IMG') {
        main.src = src.indexOf('//') === 0 ? 'https:' + src : src;
        if (srcset) main.srcset = srcset;
        main.alt = alt || '';
      }
    }

    updateUrl(variant) {
      if (!this.productUrl || !variant) return;
      var url = new URL(this.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ variantId: variant.id }, '', url.pathname + url.search);
    }

    syncFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var variantId = params.get('variant');
      if (!variantId) {
        this.currentVariant = this.product.variants.find(function (v) {
          return v.id === parseInt(this.idInput.value, 10);
        }.bind(this));
        return;
      }

      var variant = this.product.variants.find(function (v) {
        return v.id === parseInt(variantId, 10);
      });
      if (!variant) return;

      variant.options.forEach(function (value, index) {
        var fieldset = document.querySelector('[data-option-index="' + index + '"]');
        if (!fieldset) return;
        $$('.av-pdp__option-btn', fieldset).forEach(function (btn) {
          btn.classList.toggle('av-pdp__option-btn--selected', btn.dataset.optionValue === value);
        });
        var valueEl = document.querySelector('[data-option-value="' + index + '"]');
        if (valueEl) valueEl.textContent = value;
      });

      this.currentVariant = variant;
      this.idInput.value = variant.id;
      this.updatePrice(variant);
      this.updateAvailability(variant);
      this.updateImage(variant);
    }

    bindAddToCart() {
      var self = this;
      var addText = $('[data-add-to-cart-text]', this);
      if (addText) addText.dataset.defaultLabel = addText.textContent;

      this.form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = $('[data-add-to-cart]', self);
        if (btn) {
          btn.disabled = true;
          btn.classList.add('av-btn--loading');
        }

        var formData = new FormData(self.form);

        fetch(AV.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: formData
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw data;
              return data;
            });
          })
          .then(function (item) {
            return fetch(AV.routes.cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) {
              return r.json();
            }).then(function (cart) {
              AV.dispatch('cart:updated', {
                item: item,
                item_count: cart.item_count,
                open: true
              });
              updateCartCount(cart.item_count);
            });
          })
          .catch(function (err) {
            console.error('[VariantSelector] add to cart failed', err);
            var msg = (err && err.description) || 'Could not add to cart';
            announce(msg);
          })
          .finally(function () {
            if (btn) {
              btn.disabled = !self.currentVariant || !self.currentVariant.available;
              btn.classList.remove('av-btn--loading');
            }
          });
      });
    }
  }

  /* ─── PredictiveSearch ─── */
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.input = $('[data-predictive-input]', this);
      this.results = $('[data-predictive-results]', this);
      this.clearBtn = $('[data-predictive-clear]', this);
      if (!this.input || !this.results) return;

      this.debouncedSearch = AV.debounce(this.search.bind(this), 280);
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.clearBtn && this.clearBtn.addEventListener('click', this.clear.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
      this.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    onInput() {
      var q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = q.length === 0;
      if (q.length < 2) {
        this.closeResults();
        return;
      }
      this.debouncedSearch(q);
    }

    onFocus() {
      if (this.input.value.trim().length >= 2 && this.results.innerHTML) {
        this.results.hidden = false;
      }
    }

    onDocumentClick(e) {
      if (!this.contains(e.target)) this.closeResults();
    }

    onKeyDown(e) {
      if (e.key === 'Escape') {
        this.closeResults();
        this.input.blur();
      }
    }

    clear() {
      this.input.value = '';
      if (this.clearBtn) this.clearBtn.hidden = true;
      this.closeResults();
      this.input.focus();
    }

    closeResults() {
      this.results.hidden = true;
      this.results.innerHTML = '';
    }

    search(query) {
      var self = this;

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      var url = AV.routes.predictiveSearchUrl +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { signal: this.abortController.signal, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.av-predictive-results') ||
            doc.querySelector('[data-predictive-results]') ||
            doc.querySelector('.predictive-search');

          if (section) {
            self.results.innerHTML = section.innerHTML;
          } else {
            self.renderFallback(doc, query);
          }
          self.results.hidden = false;
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          self.fetchJSONSearch(query);
        });
    }

    fetchJSONSearch(query) {
      var self = this;
      var url = AV.routes.predictiveSearchUrl +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6';

      fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            self.results.innerHTML = '<p class="av-predictive-search__empty">' +
              (AV.strings.searchNoResults || 'No results') + '</p>';
          } else {
            self.results.innerHTML = '<ul class="av-predictive-search__list" role="list">' +
              products.map(function (p) {
                var img = p.image
                  ? '<img src="' + escapeHtml(p.image) + '" alt="" class="av-predictive-search__result-img" width="48" height="48" loading="lazy">'
                  : '';
                var price = p.price ? '<span class="av-predictive-search__result-price av-telemetry">' + AV.formatMoney(p.price) + '</span>' : '';
                return '<li><a class="av-predictive-search__result" href="' + escapeHtml(p.url) + '">' + img +
                  '<span class="av-predictive-search__result-info"><span class="av-predictive-search__result-title">' + escapeHtml(p.title) + '</span>' + price + '</span></a></li>';
              }).join('') + '</ul>';
          }
          self.results.hidden = false;
        })
        .catch(function () {
          self.results.innerHTML = '<p class="av-predictive-search__empty">' +
            (AV.strings.searchNoResults || 'No results') + '</p>';
          self.results.hidden = false;
        });
    }

    renderFallback(doc, query) {
      var items = doc.querySelectorAll('a[href*="/products/"]');
      if (!items.length) {
        this.results.innerHTML = '<p class="av-predictive-search__empty">' +
          (AV.strings.searchNoResults || 'No results') + '</p>';
        return;
      }
      var html = '<ul class="av-predictive-search__list" role="list">';
      items.forEach(function (link, i) {
        if (i >= 6) return;
        html += '<li><a class="av-predictive-search__result" href="' + link.href + '">' + link.textContent.trim() + '</a></li>';
      });
      html += '</ul>';
      this.results.innerHTML = html;
    }
  }

  /* ─── LocalizationForm ─── */
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      var select = $('[data-localization-select]', this);
      var form = $('form', this);
      if (!select || !form) return;
      select.addEventListener('change', function () {
        form.submit();
      });
    }
  }

  /* ─── Quick Add (collection cards) ─── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.add('av-btn--loading');

      fetch(AV.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function (item) {
          return fetch(AV.routes.cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) {
            return r.json();
          }).then(function (cart) {
            return { item: item, cart: cart };
          });
        })
        .then(function (result) {
          updateCartCount(result.cart.item_count);
          AV.dispatch('cart:updated', { item: result.item, item_count: result.cart.item_count, open: true });
          announce(AV.strings.addToCart || 'Added to cart');
        })
        .catch(function (err) {
          console.error('[QuickAdd] failed', err);
          announce((err && err.description) || 'Could not add to cart');
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('av-btn--loading');
        });
    });
  }

  /* ─── WebGL Hero ─── */
  class WebglHero extends HTMLElement {
    constructor() {
      super();
      this.gl = null;
      this.program = null;
      this.texture = null;
      this.raf = null;
      this.startTime = performance.now();
      this.mouse = { x: 0, y: 0 };
      this.rotation = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.canvas = $('[data-webgl-canvas]', this);
      this.fpsEl = $('[data-webgl-fps]', this);
      if (!this.canvas) return;

      if (this.reducedMotion) {
        this.canvas.style.display = 'none';
        return;
      }

      this.initGL();
      this.bindEvents();
      this.loadTexture().then(this.startRender.bind(this));
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    bindEvents() {
      var self = this;
      this.onMouseMove = function (e) {
        var rect = self.getBoundingClientRect();
        self.mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        self.mouse.y = ((e.clientY - rect.top) / rect.height) * 2 - 1;
      };
      this.addEventListener('mousemove', this.onMouseMove);

      this.resizeObserver = new ResizeObserver(function () {
        self.resize();
      });
      this.resizeObserver.observe(this);
    }

    initGL() {
      this.gl = this.canvas.getContext('webgl', { alpha: true, antialias: true, powerPreference: 'high-performance' });
      if (!this.gl) {
        this.canvas.style.display = 'none';
        return;
      }

      var gl = this.gl;
      var vsSource = [
        'attribute vec3 aPosition;',
        'attribute vec2 aUv;',
        'uniform mat4 uMatrix;',
        'varying vec2 vUv;',
        'void main() {',
        '  vUv = aUv;',
        '  gl_Position = uMatrix * vec4(aPosition, 1.0);',
        '}'
      ].join('\n');

      var fsSource = [
        'precision mediump float;',
        'varying vec2 vUv;',
        'uniform sampler2D uTexture;',
        'uniform float uTime;',
        'uniform vec3 uGlow;',
        'void main() {',
        '  vec2 uv = vUv;',
        '  float scan = sin((uv.y + uTime * 0.15) * 120.0) * 0.04;',
        '  vec4 tex = texture2D(uTexture, uv);',
        '  float edge = smoothstep(0.0, 0.08, uv.x) * smoothstep(1.0, 0.92, uv.x);',
        '  edge *= smoothstep(0.0, 0.08, uv.y) * smoothstep(1.0, 0.92, uv.y);',
        '  vec3 rim = uGlow * pow(1.0 - edge, 2.5) * 0.6;',
        '  vec3 color = tex.rgb + rim + scan;',
        '  float alpha = tex.a * 0.95;',
        '  gl_FragColor = vec4(color, alpha);',
        '}'
      ].join('\n');

      var vs = this.compileShader(gl.VERTEX_SHADER, vsSource);
      var fs = this.compileShader(gl.FRAGMENT_SHADER, fsSource);
      if (!vs || !fs) return;

      this.program = gl.createProgram();
      gl.attachShader(this.program, vs);
      gl.attachShader(this.program, fs);
      gl.linkProgram(this.program);

      if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
        console.error('[WebglHero] program link failed');
        return;
      }

      this.buffers = this.createCapsule(48, 24);
      this.uniforms = {
        matrix: gl.getUniformLocation(this.program, 'uMatrix'),
        texture: gl.getUniformLocation(this.program, 'uTexture'),
        time: gl.getUniformLocation(this.program, 'uTime'),
        glow: gl.getUniformLocation(this.program, 'uGlow')
      };

      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      this.resize();
    }

    compileShader(type, source) {
      var gl = this.gl;
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error('[WebglHero] shader error', gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    createCapsule(segments, rings) {
      var gl = this.gl;
      var positions = [];
      var uvs = [];
      var indices = [];
      var radius = 0.55;
      var height = 1.6;

      for (var ring = 0; ring <= rings; ring++) {
        var v = ring / rings;
        var y = (v - 0.5) * height;
        var cap = Math.abs(v - 0.5) * 2;
        var r = radius * (1 - Math.pow(cap, 3) * 0.35);

        for (var seg = 0; seg <= segments; seg++) {
          var u = seg / segments;
          var theta = u * Math.PI * 2;
          positions.push(Math.cos(theta) * r, y, Math.sin(theta) * r);
          uvs.push(u, 1 - v);
        }
      }

      for (var ri = 0; ri < rings; ri++) {
        for (var si = 0; si < segments; si++) {
          var a = ri * (segments + 1) + si;
          var b = a + segments + 1;
          indices.push(a, b, a + 1);
          indices.push(b, b + 1, a + 1);
        }
      }

      var posBuf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, posBuf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);

      var uvBuf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, uvBuf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(uvs), gl.STATIC_DRAW);

      var idxBuf = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, idxBuf);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);

      return { posBuf: posBuf, uvBuf: uvBuf, idxBuf: idxBuf, count: indices.length };
    }

    loadTexture() {
      var self = this;
      var url = this.dataset.textureUrl;
      return new Promise(function (resolve) {
        if (!self.gl) { resolve(); return; }

        var gl = self.gl;
        var tex = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, tex);

        var pixel = new Uint8Array([0, 240, 255, 200]);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        self.texture = tex;

        if (!url) { resolve(); return; }

        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          gl.bindTexture(gl.TEXTURE_2D, tex);
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
          resolve();
        };
        img.onerror = function () { resolve(); };
        img.src = url;
      });
    }

    resize() {
      if (!this.gl) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = this.clientWidth;
      var h = this.clientHeight;
      this.canvas.width = w * dpr;
      this.canvas.height = h * dpr;
      this.canvas.style.width = w + 'px';
      this.canvas.style.height = h + 'px';
      this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    }

    multiply(a, b) {
      var out = new Float32Array(16);
      for (var i = 0; i < 4; i++) {
        for (var j = 0; j < 4; j++) {
          out[j * 4 + i] =
            a[i] * b[j * 4] + a[4 + i] * b[j * 4 + 1] + a[8 + i] * b[j * 4 + 2] + a[12 + i] * b[j * 4 + 3];
        }
      }
      return out;
    }

    perspective(fov, aspect, near, far) {
      var f = 1 / Math.tan(fov / 2);
      var nf = 1 / (near - far);
      return new Float32Array([
        f / aspect, 0, 0, 0,
        0, f, 0, 0,
        0, 0, (far + near) * nf, -1,
        0, 0, 2 * far * near * nf, 0
      ]);
    }

    translate(x, y, z) {
      return new Float32Array([
        1, 0, 0, 0,
        0, 1, 0, 0,
        0, 0, 1, 0,
        x, y, z, 1
      ]);
    }

    rotateY(angle) {
      var c = Math.cos(angle);
      var s = Math.sin(angle);
      return new Float32Array([
        c, 0, s, 0,
        0, 1, 0, 0,
        -s, 0, c, 0,
        0, 0, 0, 1
      ]);
    }

    rotateX(angle) {
      var c = Math.cos(angle);
      var s = Math.sin(angle);
      return new Float32Array([
        1, 0, 0, 0,
        0, c, -s, 0,
        0, s, c, 0,
        0, 0, 0, 1
      ]);
    }

    startRender() {
      if (!this.gl || !this.program) return;
      var self = this;
      var lastFps = performance.now();
      var frames = 0;

      function frame(now) {
        self.raf = requestAnimationFrame(frame);
        var t = (now - self.startTime) / 1000;
        self.rotation += 0.004 + self.mouse.x * 0.002;

        self.render(t);

        frames++;
        if (now - lastFps > 1000) {
          if (self.fpsEl) self.fpsEl.textContent = 'FPS::' + frames;
          frames = 0;
          lastFps = now;
        }
      }

      this.raf = requestAnimationFrame(frame);
    }

    render(time) {
      var gl = this.gl;
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.enable(gl.DEPTH_TEST);

      gl.useProgram(this.program);

      var aspect = this.canvas.width / this.canvas.height;
      var proj = this.perspective(Math.PI / 4, aspect, 0.1, 100);
      var view = this.translate(0, 0, -3.2);
      var rotY = this.rotateY(this.rotation);
      var rotX = this.rotateX(this.mouse.y * 0.25 + Math.sin(time * 0.5) * 0.08);
      var model = this.multiply(rotY, rotX);
      var mv = this.multiply(view, model);
      var mvp = this.multiply(proj, mv);

      gl.uniformMatrix4fv(this.uniforms.matrix, false, mvp);
      gl.uniform1f(this.uniforms.time, time);
      gl.uniform3f(this.uniforms.glow, 0, 0.94, 1);

      var posLoc = gl.getAttribLocation(this.program, 'aPosition');
      var uvLoc = gl.getAttribLocation(this.program, 'aUv');

      gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers.posBuf);
      gl.enableVertexAttribArray(posLoc);
      gl.vertexAttribPointer(posLoc, 3, gl.FLOAT, false, 0, 0);

      gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers.uvBuf);
      gl.enableVertexAttribArray(uvLoc);
      gl.vertexAttribPointer(uvLoc, 2, gl.FLOAT, false, 0, 0);

      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, this.texture);
      gl.uniform1i(this.uniforms.texture, 0);

      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffers.idxBuf);
      gl.drawElements(gl.TRIANGLES, this.buffers.count, gl.UNSIGNED_SHORT, 0);
    }
  }

  /* ─── FacetFilters ─── */
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId || 'main-collection-grid';
      this.bindForm();
      var self = this;
      this.addEventListener('click', function (e) {
        var link = e.target.closest('[data-pagination-link]');
        if (!link) return;
        e.preventDefault();
        self.renderFromUrl(link.href);
      });
    }

    bindForm() {
      var self = this;
      this.form = $('[data-facet-form]', this);
      if (!this.form || this.form.dataset.bound) return;
      this.form.dataset.bound = 'true';
      var debouncedFilter = AV.debounce(function () { self.render(); }, 400);
      this.form.addEventListener('input', debouncedFilter);
      this.form.addEventListener('change', debouncedFilter);
      var sort = $('[data-sort-select]', this);
      if (sort) sort.addEventListener('change', debouncedFilter);
    }

    buildUrl() {
      var url = new URL(window.location.pathname, window.location.origin);
      var formData = new FormData(this.form);
      formData.forEach(function (value, key) {
        if (value) url.searchParams.append(key, value);
      });
      var sort = $('[data-sort-select]', this);
      if (sort && sort.value) url.searchParams.set('sort_by', sort.value);
      return url;
    }

    render() {
      var url = this.buildUrl();
      window.history.pushState({}, '', url.toString());
      this.renderFromUrl(url.toString());
    }

    renderFromUrl(pageUrl) {
      var self = this;
      var url = new URL(pageUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      this.classList.add('av-collection--loading');

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-section-id="' + self.sectionId + '"]') || doc.querySelector('facet-filters');
          if (!fresh) return;

          var grid = $('[data-product-grid]', fresh);
          var main = $('[data-collection-main]', fresh);
          var panel = $('[data-filters-panel]', fresh);
          var localGrid = $('[data-product-grid]', self);
          var localMain = $('[data-collection-main]', self);
          var localPanel = $('[data-filters-panel]', self);

          if (grid && localGrid) localGrid.innerHTML = grid.innerHTML;
          if (main && localMain) {
            var pag = $('.av-pagination', main);
            var localPag = $('.av-pagination', localMain);
            if (pag && localPag) localPag.replaceWith(pag);
            else if (pag) localMain.appendChild(pag);
            else if (localPag) localPag.remove();
          }
          if (panel && localPanel) localPanel.innerHTML = panel.innerHTML;
          self.bindForm();
        })
        .catch(function (err) { console.error('[FacetFilters]', err); })
        .finally(function () { self.classList.remove('av-collection--loading'); });
    }
  }

  /* ─── StickyAtc ─── */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = $('[data-sticky-form]', this);
      this.buyBox = document.querySelector('[data-buy-box]');
      this.jsonEl = document.getElementById(this.dataset.productJsonId);
      if (!this.form || !this.buyBox) { this.hidden = true; return; }

      var self = this;
      var observer = new IntersectionObserver(function (entries) {
        self.hidden = entries[0].isIntersecting;
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      observer.observe(this.buyBox);

      var select = $('[data-sticky-variant-select]', this);
      if (select) {
        select.addEventListener('change', function () {
          var id = $('[data-sticky-variant-id]', self);
          if (id) id.value = select.value;
          if (self.jsonEl) {
            try {
              var product = JSON.parse(self.jsonEl.textContent);
              var v = product.variants.find(function (x) { return x.id === parseInt(select.value, 10); });
              if (v) {
                $('[data-sticky-price]', self).textContent = AV.formatMoney(v.price);
                $('[data-sticky-submit]', self).disabled = !v.available;
              }
            } catch (e) {}
          }
        });
      }

      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-sticky-submit]', self);
        if (btn) btn.disabled = true;
        fetch(AV.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: new FormData(self.form)
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function (item) {
            return fetch(AV.routes.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
              return { item: item, cart: cart };
            });
          })
          .then(function (result) {
            updateCartCount(result.cart.item_count);
            AV.dispatch('cart:updated', { item: result.item, item_count: result.cart.item_count, open: true });
          })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    }
  }

  /* ─── Header utilities ─── */
  function initNexusHeader() {
    var header = document.querySelector('[data-av-header]');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('av-nexus--scrolled', window.scrollY > 8);
    }, { passive: true });
    var toggle = header.querySelector('[data-mobile-toggle]');
    var mobile = header.querySelector('[data-mobile-nav]');
    if (toggle && mobile) {
      toggle.addEventListener('click', function () {
        var open = mobile.hidden;
        mobile.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
  }

  function initMegaMenu() {
    document.querySelectorAll('.av-nexus__nav-item--has-mega').forEach(function (item) {
      var link = $('.av-nexus__nav-link', item);
      var mega = $('.av-nexus__mega', item);
      if (!link || !mega) return;
      link.addEventListener('mouseenter', function () { mega.hidden = false; link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { mega.hidden = true; link.setAttribute('aria-expanded', 'false'); });
    });
  }

  function initLazySections() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.av-lazy-section').forEach(function (el) { el.classList.add('av-lazy-section--visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('av-lazy-section--visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '120px' });
    document.querySelectorAll('.av-lazy-section').forEach(function (el) { io.observe(el); });
  }

  function initCarousels() {
    document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
      var wrap = track.closest('.av-carousel');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = '1';

      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb[data-gallery-thumb]'));
      if (!main || thumbs.length < 1) return;

      var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) current = 0;

      function show(index) {
        current = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[current];
        var src = thumb.dataset.galleryThumb;
        var alt = thumb.dataset.galleryAlt || '';
        main.style.opacity = '0';
        window.setTimeout(function () {
          main.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '" class="product-gallery__img" width="1200" height="1200" loading="lazy">';
          main.style.opacity = '1';
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
        }, 120);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      if (thumbs.length > 1) {
        gallery.classList.add('product-gallery--swipeable');
        var swipeArea = gallery.querySelector('.product-gallery__main') || gallery.querySelector('.product-gallery__stage');
        var startX = 0;
        var tracking = false;

        swipeArea.addEventListener('touchstart', function (e) {
          if (!e.touches.length) return;
          startX = e.touches[0].clientX;
          tracking = true;
        }, { passive: true });

        swipeArea.addEventListener('touchend', function (e) {
          if (!tracking || !e.changedTouches.length) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 48) return;
          show(dx < 0 ? current + 1 : current - 1);
        }, { passive: true });

        swipeArea.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
        });

        if (!swipeArea.hasAttribute('tabindex')) {
          swipeArea.setAttribute('tabindex', '0');
          swipeArea.setAttribute('role', 'region');
          swipeArea.setAttribute('aria-label', 'Product images');
        }
      }
    });
  }

  function initHeader() {
    var header = document.querySelector('[data-av-header]');
    if (!header) return;

    window.addEventListener('scroll', function () {
      header.classList.toggle('av-header--scrolled', window.scrollY > 8);
    }, { passive: true });

    var toggle = header.querySelector('[data-mobile-menu-toggle]');
    var mobileNav = header.querySelector('[data-mobile-nav]');
    if (toggle && mobileNav) {
      toggle.addEventListener('click', function () {
        var open = mobileNav.hidden;
        mobileNav.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('av-body--menu-open', open);
      });
    }

    var clock = header.querySelector('[data-telemetry-clock]');
    if (clock) {
      function tick() {
        var now = new Date();
        var h = String(now.getHours()).padStart(2, '0');
        var m = String(now.getMinutes()).padStart(2, '0');
        var s = String(now.getSeconds()).padStart(2, '0');
        clock.textContent = 'SYS::' + h + ':' + m + ':' + s;
      }
      tick();
      setInterval(tick, 1000);
    }
  }

  /* ─── ScrollSequence (image sequence on scroll) ─── */
  class ScrollSequence extends HTMLElement {
    constructor() {
      super();
      this.images = [];
      this.syntheticBase = null;
      this.syntheticCount = 0;
      this.currentFrame = -1;
      this.progress = 0;
      this.raf = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.canvas = this.querySelector('[data-seq-canvas]');
      this.configEl = this.querySelector('[data-seq-config]');
      this.scenes = Array.prototype.slice.call(this.querySelectorAll('[data-scene]'));
      this.frameLabel = this.querySelector('[data-seq-frame-label]');
      this.progressLabel = this.querySelector('[data-seq-progress-label]');
      this.hint = this.querySelector('[data-seq-hint]');
      this.fpsEl = this.querySelector('[data-seq-fps]');
      this.particles = this.querySelector('[data-seq-particles]');
      this.protocolEls = Array.prototype.slice.call(this.querySelectorAll('[data-protocol]'));

      if (!this.canvas || !this.configEl) return;

      this.ctx = this.canvas.getContext('2d', { alpha: false });
      this.config = JSON.parse(this.configEl.textContent);

      this.classList.add('av-seq--loading');
      this.bindEvents();
      this.loadFrames();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    bindEvents() {
      this.onScroll = this.handleScroll.bind(this);
      this.onResize = this.handleResize.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    loadFrames() {
      var self = this;
      var urls = (this.config.frames || []).filter(Boolean);

      if (urls.length === 0 && this.config.fallback) {
        this.syntheticCount = parseInt(this.dataset.synthetic, 10) || 48;
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          self.syntheticBase = img;
          self.images = new Array(self.syntheticCount);
          self.finishLoad();
        };
        img.onerror = function () { self.drawPlaceholder(); };
        img.src = this.config.fallback.indexOf('//') === 0 ? 'https:' + this.config.fallback : this.config.fallback;
        return;
      }

      if (urls.length === 0) {
        this.drawPlaceholder();
        return;
      }

      var loaded = 0;
      this.images = new Array(urls.length);

      urls.forEach(function (url, i) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          self.images[i] = img;
          loaded++;
          if (loaded === urls.length) self.finishLoad();
        };
        img.onerror = function () {
          loaded++;
          if (loaded === urls.length) self.finishLoad();
        };
        img.src = url.indexOf('//') === 0 ? 'https:' + url : url;
      });
    }

    buildSyntheticFrames(url, count) {
      var self = this;
      return new Promise(function (resolve) {
        var base = new Image();
        base.crossOrigin = 'anonymous';
        base.onload = function () {
          var frames = [];
          var w = base.naturalWidth;
          var h = base.naturalHeight;
          var off = document.createElement('canvas');
          off.width = w;
          off.height = h;
          var ctx = off.getContext('2d');

          for (var i = 0; i < count; i++) {
            var t = i / (count - 1);
            var scale = 1 + t * 0.18;
            var rot = (t - 0.5) * 0.06;
            ctx.fillStyle = '#030407';
            ctx.fillRect(0, 0, w, h);
            ctx.save();
            ctx.translate(w / 2, h / 2);
            ctx.rotate(rot);
            ctx.scale(scale, scale);
            ctx.drawImage(base, -w / 2, -h / 2, w, h);
            ctx.restore();

            var frame = new Image();
            frame.src = off.toDataURL('image/jpeg', 0.82);
            frames.push(frame);
          }

          var pending = frames.length;
          frames.forEach(function (f, idx) {
            f.onload = function () {
              pending--;
              if (pending === 0) resolve(frames);
            };
            if (f.complete) {
              pending--;
              if (pending === 0) resolve(frames);
            }
          });
          if (pending === 0) resolve(frames);
        };
        base.onerror = function () { resolve([]); };
        base.src = url.indexOf('//') === 0 ? 'https:' + url : url;
      });
    }

    finishLoad() {
      if (!this.syntheticBase) {
        this.images = this.images.filter(Boolean);
      }
      this.classList.remove('av-seq--loading');
      this.classList.add('av-seq--ready');
      this.handleResize();
      this.handleScroll();
    }

    drawPlaceholder() {
      if (!this.ctx) return;
      var w = this.canvas.width;
      var h = this.canvas.height;
      var grd = this.ctx.createLinearGradient(0, 0, w, h);
      grd.addColorStop(0, '#030407');
      grd.addColorStop(0.5, '#0e1116');
      grd.addColorStop(1, '#030407');
      this.ctx.fillStyle = grd;
      this.ctx.fillRect(0, 0, w, h);
      this.ctx.fillStyle = 'rgba(0,240,255,0.15)';
      this.ctx.font = '14px monospace';
      this.ctx.fillText('UPLOAD FRAMES IN THEME EDITOR', w / 2 - 140, h / 2);
    }

    handleResize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = this.canvas.clientWidth;
      var h = this.canvas.clientHeight;
      if (!w || !h) return;
      this.canvas.width = w * dpr;
      this.canvas.height = h * dpr;
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (this.images.length || this.syntheticBase) {
        var idx = this.syntheticBase ? this.currentFrame : (this.currentFrame >= 0 ? this.currentFrame : 0);
        if (this.syntheticBase || this.images.length) this.drawFrame(idx >= 0 ? idx : 0);
      }
    }

    handleScroll() {
      if (this.raf) return;
      var self = this;
      this.raf = requestAnimationFrame(function () {
        self.raf = null;
        self.tick();
      });
    }

    tick() {
      var rect = this.getBoundingClientRect();
      var scrollRange = this.offsetHeight - window.innerHeight;
      if (scrollRange <= 0) scrollRange = 1;
      var progress = Math.max(0, Math.min(1, -rect.top / scrollRange));

      if (this.reducedMotion) progress = progress > 0.5 ? 1 : 0;

      this.progress = progress;

      if (this.hint) {
        this.hint.classList.toggle('is-hidden', progress > 0.04);
      }

      if (this.images.length || this.syntheticBase) {
        var total = this.syntheticBase ? this.syntheticCount : this.images.length;
        var idx = Math.round(progress * (total - 1));
        this.drawFrame(idx);
      }

      if (this.frameLabel) {
        var totalFrames = this.syntheticBase ? this.syntheticCount : this.images.length;
        var pad = String(Math.max(1, (this.currentFrame + 1) || 1)).padStart(3, '0');
        this.frameLabel.textContent = 'FRAME::' + pad + '/' + String(totalFrames || 1).padStart(3, '0');
      }
      if (this.progressLabel) {
        this.progressLabel.textContent = 'PROGRESS::' + Math.round(progress * 100) + '%';
      }

      this.updateScenes(progress);
      this.updateOverlays(progress);
    }

    updateOverlays(progress) {
      if (this.particles) {
        var particleOpacity = progress < 0.2 ? 1 - progress * 2 : Math.max(0, 0.35 - (progress - 0.2) * 0.4);
        this.particles.style.setProperty('--av-seq-particles', String(Math.max(0.15, particleOpacity)));
      }

      this.protocolEls.forEach(function (el) {
        var at = parseFloat(el.style.getPropertyValue('--av-protocol-at')) || 0.6;
        var visible = progress >= at - 0.02 && progress <= 0.82;
        el.classList.toggle('is-visible', visible);
      });
    }

    drawFrame(index) {
      if (!this.ctx) return;

      if (this.syntheticBase) {
        var total = this.syntheticCount;
        index = Math.max(0, Math.min(total - 1, index));
        if (index === this.currentFrame) return;
        this.currentFrame = index;

        var cw = this.canvas.clientWidth;
        var ch = this.canvas.clientHeight;
        var img = this.syntheticBase;
        var iw = img.naturalWidth;
        var ih = img.naturalHeight;
        var t = index / (total - 1);
        var scale = Math.max(cw / iw, ch / ih) * (1 + t * 0.22);
        var rot = (t - 0.5) * 0.08;
        var dw = iw * scale;
        var dh = ih * scale;
        var dx = (cw - dw) / 2;
        var dy = (ch - dh) / 2;

        this.ctx.fillStyle = '#030407';
        this.ctx.fillRect(0, 0, cw, ch);
        this.ctx.save();
        this.ctx.translate(cw / 2, ch / 2);
        this.ctx.rotate(rot);
        this.ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
        this.ctx.restore();
        return;
      }

      if (!this.images.length) return;
      index = Math.max(0, Math.min(this.images.length - 1, index));
      if (index === this.currentFrame && this.images[index].complete) return;

      var img = this.images[index];
      if (!img || !img.complete) return;

      this.currentFrame = index;
      var cw = this.canvas.clientWidth;
      var ch = this.canvas.clientHeight;
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      var scale = Math.max(cw / iw, ch / ih);
      var dw = iw * scale;
      var dh = ih * scale;
      var dx = (cw - dw) / 2;
      var dy = (ch - dh) / 2;

      this.ctx.fillStyle = '#030407';
      this.ctx.fillRect(0, 0, cw, ch);
      this.ctx.drawImage(img, dx, dy, dw, dh);
    }

    updateScenes(progress) {
      this.scenes.forEach(function (scene) {
        var start = parseFloat(scene.dataset.sceneStart) || 0;
        var end = parseFloat(scene.dataset.sceneEnd) || 1;
        var active = progress >= start && progress <= end;
        scene.classList.toggle('is-active', active);
        scene.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('scroll-sequence')) {
    customElements.define('scroll-sequence', ScrollSequence);
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  if (!customElements.get('ajax-cart')) {
    customElements.define('ajax-cart', class extends CartDrawer {});
  }
  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }
  if (!customElements.get('variant-selector')) {
    customElements.define('variant-selector', class extends VariantSelects {});
  }
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }
  if (!customElements.get('webgl-hero')) {
    customElements.define('webgl-hero', WebglHero);
  }
  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }
  if (!customElements.get('sticky-atc')) {
    customElements.define('sticky-atc', StickyAtc);
  }

  function initAll() {
    initNexusHeader();
    initHeader();
    initMegaMenu();
    initQuickAdd();
    initLazySections();
    initCarousels();
    initProductGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

